'use strict';

var React = require('react');
var array = require('../../../helpers/array.js');
var functions = require('../../../helpers/functions.js');
require('../../Tooltip/component.js');
require('../../Pill/pill.styles.js');
var pillButton = require('../../Pill/pillButton.js');
var filterPopin_styles = require('./filterPopin.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const FilterPillPopin = ({ id, node = { current: null }, queryParam, colKey, title, pills, isPopinRightSide = false, $top, $left, addToQueryParams = functions.noop, removeFromQueryParams = functions.noop, isSelectOneValue = false, labelCheckAll = 'Tous', }) => {
    const [filterValue, setFilterValue] = React.useState(queryParam?.key === colKey && queryParam?.value && Array.isArray(queryParam?.value)
        ? queryParam.value
        : []);
    const onSortBy = (param) => {
        removeFromQueryParams({ key: colKey });
        if (param.value.length > 0) {
            addToQueryParams({ ...param, key: colKey });
        }
    };
    const onCheckChange = (filterVal) => () => {
        let newCheckboxes = array.addOrRemove(filterValue, filterVal);
        if (isSelectOneValue) {
            newCheckboxes = newCheckboxes.filter(v => v === filterVal);
        }
        setFilterValue(newCheckboxes);
        onSortBy({ value: newCheckboxes });
    };
    const onCheckChangeAll = (e) => {
        let newCheckboxes;
        if (filterValue.length === pills.length) {
            newCheckboxes = [];
        }
        else {
            newCheckboxes = pills.map(c => c.value);
        }
        setFilterValue(newCheckboxes);
        onSortBy({ value: newCheckboxes });
    };
    return (React__default.default.createElement(filterPopin_styles.ContainerPillStyled, { id: id, ref: node, isPopinRightSide: isPopinRightSide, "$top": $top, "$left": $left, "$width": "auto", popinRect: node },
        React__default.default.createElement(filterPopin_styles.FilterTitle, null, title),
        !isSelectOneValue && (React__default.default.createElement(filterPopin_styles.FlexDivAll, null,
            React__default.default.createElement(filterPopin_styles.Checkbox, { name: "all", id: `${id}-check-all`, checked: pills.map(c => c.value).every(c => filterValue.includes(c)), onChange: onCheckChangeAll }),
            React__default.default.createElement(filterPopin_styles.LabelStyled, { htmlFor: `${id}-check-all` }, labelCheckAll))),
        React__default.default.createElement(filterPopin_styles.FlexDivPill, null, pills.map(pill => (React__default.default.createElement(pillButton.PillButton, { id: `${id}-pill-${pill.value}`, key: pill.value.toString(), color: pill.color, label: pill.label, value: pill.value, onClick: onCheckChange(pill.value), active: filterValue.includes(pill.value) }))))));
};

exports.FilterPillPopin = FilterPillPopin;
//# sourceMappingURL=filterPillPopin.js.map
